import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getCloudSolutionsPath } from "@core/schema/paths/getCloudSolutionsPath.js";

export function getFaqsProduction(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak dlouho trvá vývoj interního systému na míru pro výrobní firmu?",
			answer:
				"Délka vývoje závisí na rozsahu systému. Jednodušší řešení zvládneme dodat už za jednotky měsíců, komplexnější projekty vyžadují obvykle 6–9 měsíců. ",
		},
		{
			question: "Musíme od začátku přesně vědět, co od vás potřebujeme?",
			answer:
				"Stačí, když budete mít aspoň základní představu. Následně vám pomůžeme přesně definovat řešení, které přinese největší efekt. Stačí, když popíšete, co vás trápí a my se na zbytek doptáme.",
		},
		{
			question: "Umíte zachovat části starého systému a jen ho vylepšit?",
			answer:
				"Ano, pokud máte funkční části systému, které chcete ponechat, můžeme je buď integrovat, nebo na ně navázat s novým vývojem.",
		},
		{
			question: "Za jak dlouho se nám investice do systému nebo jiného softwaru na míru vrátí? ",
			answer:
				"Návratnost závisí na tom, co systém řeší. U většiny klientů se investice vrací v horizontu měsíců díky úsporám času, personálních nákladů nebo snížení chybovosti.",
		},
		{
			question: "Musíme vámi dodané řešení provozovat interně ve firmě?",
			answer: `Většinu řešení vyvíjíme na  [${getCloudSolutionsPath(tenant)}][[cloudu]], takže software nemusíte provozovat přímo u sebe ve firmě a také není třeba žádná instalace.`,
		},
		{
			question: "Dokážete připravit i evidenci docházky pro sledování zaměstnanců na vícero pobočkách?",
			answer:
				"Ano, systém umíme nastavit i tak, aby pracoval i ve více provozovnách současně. Manažeři pak mají přístup ke kompletním přehledům docházky online.",
		},
	];
}
